import React from 'react';
import MenuBottom from './menubottom';
import MenuTop from './menutop';
import { Link } from 'react-router';

class Header extends React.Component {
	render() {
		return (
            <div className='top-bar'>
                <Link to={'/'}> 
                    <img className='top-bar-logo' src='img/logo_small.png'/>
                    
                </Link>
                <MenuTop userState={this.props.userState} appActions={this.props.appActions} />
                { this.props.userState.isLoggedIn &&
                <div className='top-bar-submenu-container'>
                    <MenuBottom userState={this.props.userState} appActions={this.props.appActions} />
                </div> }
            </div>
		)
	}
}

export default Header;



// WEBPACK FOOTER //
// ./source/components/header.js